import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2d5cbf77&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d5cbf77')) {
      api.createRecord('2d5cbf77', component.options)
    } else {
      api.reload('2d5cbf77', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2d5cbf77&", function () {
      api.rerender('2d5cbf77', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/ApprovalMatters/EnterpriseWechatApprovalChecklist/index.vue"
export default component.exports